import {User} from '../models/User';
import {AuthorizationService} from '../../../Services/authorization/AuthorizationService';

export class CheckPermissionUseCase {
  private authorizationService: AuthorizationService;

  constructor () {
    this.authorizationService = AuthorizationService.getInstance();
  }

  hasPermission (user: User | null, permission: string): boolean {
    return this.authorizationService.hasPermission(user, permission);
  }

  hasAnyPermission (user: User | null, permissions: string[]): boolean {
    return this.authorizationService.hasAnyPermission(user, permissions);
  }

  hasRole (user: User | null, requiredRole: string): boolean {
    return this.authorizationService.hasRole(user, requiredRole);
  }

  hasAnyRole (user: User | null, roles: string[]): boolean {
    return this.authorizationService.hasAnyRole(user, roles);
  }

  hasAllRoles (user: User | null, roles: string[]): boolean {
    return this.authorizationService.hasAllRoles(user, roles);
  }

  canPerformAction (user: User | null, action: string, resource: string): boolean {
    return this.authorizationService.canPerformAction(user, action, resource);
  }

  getRoleLevel (user: User | null): number {
    return this.authorizationService.getRoleLevel(user);
  }

  canManageUser (user: User | null, targetUser: User | null): boolean {
    return this.authorizationService.canManageUser(user, targetUser);
  }

  isAdmin (user: User | null): boolean {
    return this.authorizationService.isAdmin(user);
  }

  hasFinancialPermissions (user: User | null): boolean {
    return this.authorizationService.hasFinancialPermissions(user);
  }

  hasManagementPermissions (user: User | null): boolean {
    return this.authorizationService.hasManagementPermissions(user);
  }
}
